import { useEffect } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
function hasResizeObserver() {
  return typeof window.ResizeObserver !== 'undefined';
}
function useResizeObserver(options) {
  const {
    ref,
    onResize
  } = options;
  useEffect(() => {
    const element = ref?.current;
    if (!element) {
      return null;
    }
    if (!hasResizeObserver()) {
      window.addEventListener('resize', onResize, false);
      // eslint-disable-next-line consistent-return
      return () => window.removeEventListener('resize', onResize, false);
    }
    const resizeObserverInstance = new window.ResizeObserver(entries => {
      if (!entries.length) {
        return null;
      }
      return onResize();
    });
    resizeObserverInstance.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      if (element) {
        resizeObserverInstance.unobserve(element);
      }
    };
  }, [onResize, ref]);
}

export { useResizeObserver };
